/**
 * Sabiha Gökçen ofis sayfası için yazılmış SEO metni (yayına hazır taslak).
 *
 * Neden bu sayfa: /r/europcar-lokasyon önceliklendirmesinde 1. sırada —
 * 30 günde 21.796 gösterim / 427 tık / CTR %1,96 / poz 7,4, kaçan tık 484.
 * Havalimanı ofislerinin CTR medyanı %3,5, hedef CTR %4,18.
 *
 * Metindeki her somut rakamın kaynağı canlı sitedir, uydurma yoktur:
 *  - ofis adresi, çalışma saati, telefon → /konumlar/istanbul/istanbul-sabiha-gokcen-havalimani
 *    (sayfa gövdesindeki ofis kartı + JSON-LD PostalAddress, 11 Ağu 2026 çekimi)
 *  - yaş / ehliyet / provizyon / CDW / km / iptal / HGS / ofis dışı saat bedeli
 *    → /yardim/europcar-kiralama-kosullari (11 Ağu 2026 çekimi)
 *  - hedeflenen sorgular → Search Console, bu sayfaya inen sorgular (son 40 gün)
 *
 * ⚠️ Koşullar sayfasındaki tutarlar değişirse metin de güncellenmeli.
 * ⚠️ TEYIT[] listesindeki maddeler Europcar'dan doğrulanmadan yayına girmemeli.
 *
 * Bilerek YOK: "gezilecek yerler", "ne yenir" gibi şablon dolgusu. Adana sayfası
 * 894 kelime yazılmasına rağmen CTR %1,58'de kaldı; metnin ~%30'u kiralamayla
 * ilgisiz bu iki bölümdü.
 */

export const SABIHA_URL =
  'https://www.europcar.com.tr/konumlar/istanbul/istanbul-sabiha-gokcen-havalimani';

export const SABIHA_META = {
  h1: 'Sabiha Gökçen Araç Kiralama',
  title: 'Sabiha Gökçen Araç Kiralama | 7/24 Ofis - Europcar Türkiye',
  desc: 'Sabiha Gökçen Havalimanı İç Hatlar\'daki Europcar ofisi 7/24 açık. Yaş ve ehliyet şartları, depozito tutarları, km sınırı ve teslim noktası tek sayfada.',
  mevcutTitle: 'Sabiha Gökçen Araç Kiralama | Hızlı Teslim - Europcar Türkiye',
  mevcutDesc: 'Sabiha Gökçen araç kiralama hizmetiyle uçaktan iner inmez yola çıkın. Europcar ile güvenli, ekonomik ve konforlu kiralama avantajı.'
};

/** Metnin hedeflediği sorgular (Search Console, son 40 gün, bu sayfaya inenler). */
export const SABIHA_HEDEF_SORGULAR = [
  { q: 'sabiha gökçen araç kiralama', imp: 7188, clk: 190, pos: 7.8, nerede: 'H1 + giriş' },
  { q: 'sabiha gökçen havalimanı araç kiralama', imp: 1553, clk: 30, pos: 8.8, nerede: 'giriş + teslim bölümü' },
  { q: 'araç kiralama sabiha gökçen', imp: 1140, clk: 38, pos: 7.5, nerede: 'giriş' },
  { q: 'sabiha gokcen araba kiralama', imp: 853, clk: 18, pos: 9.2, nerede: 'SSS (araba kiralama varyantı)' },
  { q: 'sabiha gökçen rent a car', imp: 568, clk: 6, pos: 9.1, nerede: 'giriş (rent a car geçiyor)' },
  { q: 'sabiha gökçen araç kiralama firmaları', imp: 389, clk: 4, pos: 7.5, nerede: 'ofis / teslim bölümü' },
  { q: 'sabiha gökçen oto kiralama', imp: 298, clk: 3, pos: 8.5, nerede: 'SSS' },
  { q: 'sabiha gökçen kiralık araç teslim noktası', imp: 10, clk: 0, pos: null, nerede: 'Teslim noktası bölümü — sayfada bugün hiç karşılığı yok' },
  { q: 'sabiha gökçen araç kiralama fiyatları', imp: 25, clk: 0, pos: null, nerede: 'Fiyat bölümü (mekanizma)' },
  { q: 'kredi kartsız araç kiralama sabiha gökçen', imp: 3, clk: 0, pos: null, nerede: 'SSS — dürüst "hayır" cevabı' }
];

/**
 * Metin blokları. tip: h2 | p | ul | tablo | sss
 * Kopyalama bu diziden üretilir, ekranda görünen ile birebir aynıdır.
 */
export const SABIHA_BLOKLAR = [
  {
    tip: 'p',
    metin:
      'Sabiha Gökçen Havalimanı\'nda araç kiralama ofisimiz İç Hatlar Terminali\'nde ve haftanın yedi günü, günün yirmi dört saati açık. Uçağınız gece 03:00\'te de inse ofis kapalı olmaz: aracınızı teslim alır, doğrudan yola çıkarsınız. Rezervasyonunuzu online yapabilir, ofise +90 530 827 22 23 numaralı hattan ulaşabilirsiniz. Aşağıda bu ofiste geçerli olan teslim noktası, çalışma saatleri, yaş ve ehliyet şartları, depozito tutarları ve kilometre sınırı yazılıdır — kiralamadan önce bilmeniz gereken her şey tek sayfada.'
  },

  { tip: 'h2', metin: 'Ofis nerede, teslim noktası ve çalışma saatleri' },
  {
    tip: 'ul',
    ogeler: [
      'Adres: Sabiha Gökçen Havalimanı, İç Hatlar — Pendik / İstanbul',
      'Çalışma saatleri: her gün 00:00 – 23:59 (7/24 açık, resmi tatiller dâhil)',
      'Ofis telefonu: +90 530 827 22 23 · Rezervasyon merkezi: 0850 377 0 377',
      'Teslim ve iade aynı noktada yapılır; araç teslim alınırken birlikte kontrol edilir'
    ]
  },
  {
    tip: 'p',
    metin:
      'Ofis 7/24 açık olduğu için, Europcar\'ın çalışma saati dışında teslim ve iade için uyguladığı 350 TL\'lik (KDV dâhil) hizmet bedeli bu ofiste doğmaz. Gece geç saatte inen ya da sabaha karşı uçağa yetişmek için aracı bırakan yolcular bu ücreti ödemez.'
  },
  {
    tip: 'p',
    metin:
      '[TEYİT GEREKİYOR — Europcar] Terminal çıkışından ofise yürüme tarifi: hangi kat, hangi kapı, kaç dakika. Bu cümle metnin en çok işe yarayan cümlesi olacak; ofis bilgisi gelmeden yayına alınmamalı.'
  },

  { tip: 'h2', metin: 'Uçuşunuz rötar yaparsa: uçuş numarası ve 2 saatlik araç garantisi' },
  {
    tip: 'p',
    metin:
      'Rezervasyon sırasında uçuş numaranızı mutlaka yazın. Havalimanı ofislerinde en sık yaşanan aksaklık budur: uçuş numarası girilmediğinde rötarlı iniş ofis tarafından takip edilemez. Rezerve edilen araç, rezervasyon saatinden itibaren 2 saat garanti edilir; bu süre içinde teslim alınmayan rezervasyon iptal edilir ve ücret iadesi yapılmaz. Uçuş numaranız kayıtlıysa rötardan kaynaklanan gecikmeler bu nedenle sorun yaratmaz.'
  },

  { tip: 'h2', metin: 'Kiralama şartları: sürücü yaşı, ehliyet kıdemi ve istenen belgeler' },
  {
    tip: 'tablo',
    baslik: 'Yaş ve ehliyet şartı — kiralayan ve ek sürücüler için',
    basliklar: ['Araç grubu', 'En az yaş', 'En az ehliyet kıdemi'],
    satirlar: [
      ['Ekonomik', '21', '1 yıl'],
      ['Orta', '23', '2 yıl'],
      ['SUV', '25', '2 yıl'],
      ['Minivan, Premium, Luxury', '27', '3 yıl']
    ]
  },
  {
    tip: 'ul',
    ogeler: [
      'Geçerli bir Findeks (Fanaliz) kredi notu aranır.',
      'Latin alfabesi kullanmayan ehliyet sahipleri (Rusya, Çin, Arap ülkeleri, Yunanistan vb.) kendi ehliyetlerinin yanında geçerli uluslararası ehliyet ve — T.C. vatandaşı değilse — pasaport ibraz etmelidir.',
      'Rezervasyon araç grubu üzerinden garanti edilir; marka garantisi verilmez. Ofiste uygunluk varsa aynı gruptaki tercih ettiğiniz marka verilebilir.'
    ]
  },

  { tip: 'h2', metin: 'Ödeme ve depozito: kredi kartı bloke tutarları' },
  {
    tip: 'tablo',
    baslik: 'Araç grubuna göre provizyon (bloke) ve hasar muafiyet bedeli',
    basliklar: ['Araç grubu', 'Provizyon / bloke', 'Muafiyet bedeli (CDW)'],
    satirlar: [
      ['Ekonomik', '4.000 TL', '30.000 TL'],
      ['Orta', '4.500 TL', '40.000 TL'],
      ['SUV', '5.500 TL', '50.000 TL'],
      ['Minivan', '6.500 – 10.000 TL (2 kredi kartı)', '50.000 TL'],
      ['Prestij, Premium, SUV+', '6.500 – 10.000 TL (2 kredi kartı)', '60.000 TL'],
      ['Luxury', '6.500 – 10.000 TL (2 kredi kartı)', '70.000 TL']
    ]
  },
  {
    tip: 'ul',
    ogeler: [
      'Ödeme yalnızca kredi kartıyla yapılır. Nakit ödeme, nakit bloke ve debit kart kabul edilmez.',
      'Kredi kartı kiralayan kişinin adına olmalı ve kira bedeli + bloke tutarını karşılayacak limiti bulunmalıdır.',
      'Üst ve lüks sınıf kiralamalarda kiracı adına, farklı bankalara ait 2 kredi kartı istenir; kira ve depozito ofiste tahsil edilir.',
      'Bloke edilen tutarın hesabınıza geri yansıması bankacılık işlemlerine bağlı olarak 10–15 iş gününü bulabilir. Gecikmenin nedeni Europcar değil, banka sürecidir.'
    ]
  },

  { tip: 'h2', metin: 'Sabiha Gökçen araç kiralama fiyatları neye göre değişir' },
  {
    tip: 'p',
    metin:
      'Günlük ücret sabit değildir; tarih, süre ve müsaitliğe göre değişir. Fiyatı belirleyen kalemler şunlardır: seçtiğiniz araç grubu, kiralama süresi, kilometre kullanımı, tek yön bırakış olup olmadığı, ek sürücü / çocuk koltuğu / navigasyon gibi ek hizmetler ve tercih ettiğiniz koruma paketi. Kiralama 24 saatlik periyotlarla hesaplanır: sözleşmede yazan saatten itibaren 24 saat 1 gündür, bu süreyi aşan ilk 59 dakika için ek gün ücreti alınmaz, 59 dakikayı aşan gecikmelerde bir günlük kira bedeli işler. Aylık kiralamalar 30 gün üzerinden hesaplanır.'
  },
  {
    tip: 'p',
    metin:
      'Ön ödemeli rezervasyon daha uygun fiyatlıdır, ancak tarih, saat ve araç bilgisi değiştirilemez; değişiklik için rezervasyonun iptal edilip yeniden oluşturulması gerekir. Ön ödemeli rezervasyonla kazanılan indirim başka bir kampanyayla birleştirilemez.'
  },

  { tip: 'h2', metin: 'Günlük 400 km sınırı ve Sabiha Gökçen\'den çıkan rotalar' },
  {
    tip: 'p',
    metin:
      'Araçlar günlük 400 km ile sınırlıdır; 10 gün ve üzeri kiralamalarda toplam sınır 4.000 km\'dir. Sınırın aşılması hâlinde, aşılan her kilometre için araç grubuna bağlı ek ücret alınır. Sabiha Gökçen\'den çıkacaksanız bu sınırın pratikte ne anlama geldiğini bilmek işinizi kolaylaştırır — havalimanından yaklaşık mesafeler şöyledir:'
  },
  {
    tip: 'ul',
    ogeler: [
      'Pendik 10 km · Kartal 15 km · Kadıköy 40 km · Taksim ve Sultanahmet 50 km',
      'Gebze 30 km · İzmit 65 km · Sapanca 90 km · Şile 60 km',
      'Bursa 150 km (Osmangazi Köprüsü üzerinden)'
    ]
  },
  {
    tip: 'p',
    metin:
      'Yani Sapanca veya Şile\'ye günübirlik bir gidiş-dönüş 400 km sınırının rahatlıkla içinde kalır; Bursa gidiş-dönüşü de yaklaşık 300 km\'dir. Sınırı zorlayan kullanım, birden fazla şehri aynı gün dolaşan uzun rotalardır.'
  },

  { tip: 'h2', metin: 'HGS, köprü geçişleri ve trafik cezaları' },
  {
    tip: 'p',
    metin:
      'Filodaki tüm araçlarda HGS bulunur. Kiralamanız bittiğinde geçiş bilgileri ofise ulaşır ve ücret kredi kartınızdan tahsil edilir; tahsilat Karayolları Genel Müdürlüğü\'nün bildirim süresine bağlı olduğundan olağandan geç yansıyabilir. HGS\'li araçla OGS gişesinden geçmeyin — bu kaçak geçiş sayılır; ücreti Europcar öder ve kartınızdan tahsil edilir. Kiralama süresi boyunca oluşan trafik ve park cezalarının sorumluluğu sürücüye aittir.'
  },

  { tip: 'h2', metin: 'İptal, değişiklik ve uzatma' },
  {
    tip: 'ul',
    ogeler: [
      'Başlangıç tarih ve saatinden 24 saat önce yapılan iptaller ücretsizdir.',
      '24 saatten az kala yapılan iptallerde 1 günlük kira bedeli tahsil edilir, kalan tutar iade edilir. 1 günlük rezervasyonlarda iade yapılmaz.',
      'Ön ödemeli rezervasyonların iadesi bankaya bağlı olarak 5–21 iş günü içinde kartınıza yansır.',
      'Uzatma talebi, kiralama bitiminden en az 24 saat önce ofise bildirilmelidir; uzatma ilgili ofisin onayıyla yapılır.',
      'Alış ve bırakış farklı şehirlerdeyse Europcar\'ın belirlediği tek yön ücreti tahsil edilir.'
    ]
  },

  { tip: 'h2', metin: 'Sık sorulan sorular' },
  {
    tip: 'sss',
    ogeler: [
      {
        s: 'Sabiha Gökçen\'deki Europcar ofisi 7/24 açık mı?',
        c: 'Evet. Ofis haftanın yedi günü 00:00 – 23:59 saatleri arasında hizmet verir; gece inen uçuşlarda da açıktır.'
      },
      {
        s: 'Gece geç saatte araç teslim alırsam ek ücret öder miyim?',
        c: 'Hayır. Çalışma saati dışı teslim ve iade için uygulanan 350 TL\'lik (KDV dâhil) bedel, 7/24 açık olan bu ofiste doğmaz.'
      },
      {
        s: 'Sabiha Gökçen\'de araba kiralamak için depozito ne kadar?',
        c: 'Araç grubuna göre 4.000 TL ile 10.000 TL arasında değişir: Ekonomik 4.000 TL, Orta 4.500 TL, SUV 5.500 TL, Minivan / Premium / Luxury 6.500 – 10.000 TL. Tutar, kiralayan kişinin kredi kartına bloke olarak konur.'
      },
      {
        s: 'Kredi kartı olmadan ya da banka kartıyla araç kiralayabilir miyim?',
        c: 'Hayır. Ödeme yalnızca kiralayan kişinin adına düzenlenmiş kredi kartıyla yapılır; nakit ödeme, nakit bloke ve debit kart kabul edilmez.'
      },
      {
        s: 'Kaç yaşında araç kiralayabilirim?',
        c: 'Ekonomik grupta 21 yaşını doldurmuş ve en az 1 yıllık ehliyet sahibi olmak yeterlidir. Orta grup için 23 yaş / 2 yıl, SUV için 25 yaş / 2 yıl, Minivan – Premium – Luxury için 27 yaş / 3 yıl şartı aranır.'
      },
      {
        s: 'Günlük kilometre sınırı var mı?',
        c: 'Evet, araçlar günlük 400 km ile sınırlıdır. 10 gün ve üzeri kiralamalarda toplam sınır 4.000 km\'dir; aşım hâlinde araç grubuna göre kilometre başına ek ücret alınır.'
      },
      {
        s: 'Yabancı ehliyetle araç kiralayabilir miyim?',
        c: 'Latin alfabesi kullanan ehliyetler doğrudan kabul edilir. Latin alfabesi dışı ehliyetlerde (Rusya, Çin, Arap ülkeleri, Yunanistan vb.) geçerli uluslararası ehliyet ve T.C. vatandaşı olmayanlar için pasaport ibrazı gerekir.'
      }
    ]
  }
];

/** Yayına almadan önce Europcar'dan doğrulanacaklar. */
export const SABIHA_TEYIT = [
  'Terminal içindeki tam teslim noktası: hangi kat, hangi kapı, terminal çıkışından kaç dakika. Metinde yer tutucu olarak duruyor.',
  'İç Hatlar\'daki ofis Dış Hatlar\'dan inen yolculara da hizmet veriyor mu; iki terminal arası geçiş nasıl yapılıyor.',
  'Aracın teslim edildiği otopark / kat bilgisi ve iade sırasında aracın bırakılacağı nokta.',
  'Bu ofiste bulunan araç grupları (otomatik vites, SUV, 8+1, ticari) — filo bilgisi gelirse ayrı bir bölüm eklenmeli.',
  'Mesafeler yaklaşıktır, güzergâha göre değişir; Europcar isterse kaldırılabilir veya kendi ölçümüyle değiştirilebilir.',
  'Provizyon, muafiyet, km ve 350 TL\'lik bedel 11 Ağustos 2026 tarihli kiralama koşulları sayfasından alındı. Tutarlar değişirse metin güncellenmeli.',
  '"Fiyatlar şu kadardan başlıyor" cümlesi istenirse güncel taban fiyat Europcar\'dan alınmalı — metne uydurma rakam konmadı.'
];

/** Metin dışı, sayfada yapılması gereken teknik işler. */
export const SABIHA_TEKNIK = [
  { is: 'Title ve description değiştirilmeli', not: 'Mevcut başlık "Hızlı Teslim" diyor ama sayfada teslim bilgisi yok. Önerilen başlık 7/24\'ü öne çıkarıyor — bu ofisin rakiplerden gerçek farkı bu.' },
  { is: 'FAQPage şeması eklenmeli', not: 'Sık sorulan sorular bölümü şema ile işaretlenmeli. Sixt\'in lokasyon sayfalarında FAQ şeması var, bizde yok; SERP\'te yer kaplama farkı buradan çıkıyor.' },
  { is: 'H1 korunmalı', not: '"Sabiha Gökçen Araç Kiralama" sayfanın ana kelimesiyle birebir; değiştirilmemeli. Alt başlıklar H2 olarak kurulmalı.' },
  { is: '/konumlar/istanbul sayfasından iç link', not: 'İstanbul şehir sayfası "sabiha gökçen araç kiralama" sorgusunda da görünüyor. Şehir sayfasından bu sayfaya "Sabiha Gökçen Havalimanı araç kiralama" ankoruyla link verilmeli.' },
  { is: 'Şablon dolgusu eklenmemeli', not: 'Diğer lokasyon sayfalarındaki "Gezilecek Yerler" ve "Ne Yenir" bölümleri bu metne bilerek konmadı. Adana sayfasında 894 kelimenin ~%30\'u bu iki bölümdü ve sayfa kendi ana kelimesinde 18,6. sırada.' }
];

/** Blokları düz metne çevirir — kopyala butonu bunu kullanır. */
export function sabihaMetniDuzMetin() {
  const satirlar = [SABIHA_META.h1, ''];
  for (const b of SABIHA_BLOKLAR) {
    if (b.tip === 'h2') satirlar.push(b.metin, '');
    else if (b.tip === 'p') satirlar.push(b.metin, '');
    else if (b.tip === 'ul') { b.ogeler.forEach(o => satirlar.push(`• ${o}`)); satirlar.push(''); }
    else if (b.tip === 'tablo') {
      satirlar.push(b.baslik);
      satirlar.push(b.basliklar.join(' | '));
      b.satirlar.forEach(s => satirlar.push(s.join(' | ')));
      satirlar.push('');
    } else if (b.tip === 'sss') {
      b.ogeler.forEach(o => satirlar.push(o.s, o.c, ''));
    }
  }
  return satirlar.join('\n').trim();
}

/** Kelime sayısı — gövde metni, başlıklar dâhil. */
export const SABIHA_KELIME = sabihaMetniDuzMetin().split(/\s+/).filter(Boolean).length;
